export const listbookings = {
    // Check-in de una estancia vendida por horas: los campos mínimos
    rapido: "Szybki",
  text1: "Witamy!",
  text2: "Lista check-inów: zarządzanie lub wysyłka linku do rejestracji gości.",
  text3: "Lista check-inów",
  text4: "Eksportuj",
  text5: "Nowy check-in",
  text6: "Wszystkie",
  text7: "Oczekujące",
  text8: "Zakończone",
  text9: "Dziś",
  text10: "Telefon",
  text11: "Imię",
  text12: "Numer dokumentu",
  text13: "Kraj",
  text14: "Check-in",
  text15: "Klucze",
  text16: "Wydane",
  text17: "Oczekuje",
  text18: "Zobacz pełne informacje",
  text19: "Podpisany dokument",
  text20: "Wszystkie",
  text21: "Wystąpił błąd w procesie potwierdzania wydania",
  text22: "Informacje o check-inie",
  text23: "Dane zebrane przy check-inie gościa",
  text24: "Imię",
  text25: "Nazwisko",
  text26: "Telefon",
  text27: "Data zakwaterowania",
  text28: "Typ dokumentu",
  text29: "Paszport",
  text30: "Dowód osobisty",
  text31: "Numer dokumentu",
  text32: "Ważność dokumentu",
  text33: "Narodowość",
  text34: "Data urodzenia",
  text35: "Płeć",
  text36: "Kobieta",
  text37: "Mężczyzna",
  text38: "Proszę tu wpisać ...",
  text39:
    "Dzień dobry [guest_name],\nWitamy w HOTEL BARCELO MALAGA!\n\nDziękujemy za wybór naszego hotelu. Informujemy, że check-out możliwy jest do godz. 10.00.\n\nDodatkowo przekazujemy dane dostępu do naszej sieci Wifi:\n\nSieć: HOTEL-BARCELO\nHasło: xkamakj1a0\n\n\nMamy nadzieję, że pobyt będzie jak najprzyjemniejszy.\n\nRecepcja jest do dyspozycji przez całą dobę.\n\nPozdrawiamy serdecznie!",
  text40: "Nazwa obiektu jest wymagana.",
  text41: "Zasady obiektu są wymagane.",
  text42: "Trzeba dodać wiadomość powitalną.",
  text43: "Zmiany zapisane pomyślnie",
  text44: "Błąd żądania",
  text45: "Zarejestrowano pomyślnie.",
  text46: "😃 Dzień dobry!! ",
  text47:
    " Proces tworzenia pierwszego obiektu został pomyślnie zakończony, teraz można udostępnić swój QR, aby użytkownicy mogli zrobić ",
  text48: "check-in",
  text49: "automatyczny 👍",
  text50: "Wcześniej wprowadzone pola można edytować z poziomu menu",
  text51: "Ustawienia szablonu.",
  text52: "Pobierz",
  text53: "Dalej",
  text54: "Informacje o check-inie.",
  text55: "Dane check-inu",
  text56: "Data zgłoszenia:",
  text57: " o godz.",
  text58: "Dane zebrane przy check-inie gościa",
  text59: "Imię",
  text60: "Nazwisko",
  text61: "Telefon",
  text62: "Data zakwaterowania",
  text63: "Typ dokumentu",
  text64: "Paszport",
  text65: "Dowód osobisty",
  text66: "Numer dokumentu",
  text67: "Informacje dodatkowe",
  text68: "Ważność dokumentu",
  text69: "Narodowość",
  text70: "Data urodzenia",
  text71: "Płeć",
  text72: "Kobieta",
  text73: "Mężczyzna",
  text74: "Zamknij",
  text75: "Nowy check-in",
  text76:
    "Poniższe opcje pozwalają wysłać link albo utworzyć check-in ręczny.",
  text77: "Check-in",
  text78: "Check-in ręczny z panelu administracyjnego.",
  text79: "Wyślij check-in",
  text80: "Link do rezerwacji dla gościa.",
  text81: "Wczytywanie, proszę czekać...",
  text82: "Lat",
  text83: "Dni",

  // Modal exportar
  text84: `EKSPORT`,
  text85: `Eksport raportów w WACheckin`,
  text86: `Pobierz raport check-inów`,
  text87: `Pobranie check-inów wykonanych przez gości daje
    szczegółowy raport z informacjami takimi jak data check-inu
    i inne dane.`,
  text88: `Pobierz raport migracyjny`,
  text89: `Jeśli automatyczna synchronizacja z organem migracyjnym nie zadziała,
    można pobrać ten raport i ręcznie wprowadzić dane
    gościa.`,

  text90: `Klucze wydane`,
  text91: `Organy`,
  text92: `Pobierz raport policyjny`,
  text93: `Usuń check-in`,
  text94: `W obiekcie nie ma jeszcze zarejestrowanych gości`,
  text95: `Zarejestrowani goście pojawią się tutaj`,
  text96: `EKSPORT`,
  text97: `EKSPORT`,
  text98: `EKSPORT`,

  // Corrections

  p1: `Wyślij`,
  p2: `Link do check-inu`,
  p3: `Skanuj`,
  p4: `Gość podpisze się na tym urządzeniu`,
  p5: `Zeskanowane`,
  p6: `Ręczny`,
  p7: `Operator ręczny`,
  p8: `check-iny`,
  p9: `Opcja check-inu ręcznego pozwala rejestrować gości bezpośrednio w recepcji`,
  p10: `Check-in ręczny`,
  p11: `Wysyłka linku do check-inu online przez WhatsApp lub e-mail ułatwia gościom rejestrację przed przyjazdem`,
  p12: `Wyślij check-in online`,
  p13: `Nieokreślone`,
  p14: `Usuń check-in`,
  p15: `Czy na pewno usunąć ten check-in? Usuniętych danych nie da się odzyskać`,
  p16: `Usuń`,
  p17: `Anuluj`,
  p18: `Pełnia możliwości dzięki funkcjom premium`,
  p19: `Automatyczny check-in przez WhatsApp`,
  p20: `Wysyłka dokumentów podróżnych`,
  p21: `Weryfikacja tożsamości`,
  p22: `Automatyczne oceny`,
  p23: `Sprzedaż krzyżowa`,
  p24: `Zarządzanie kluczami gości`,
  p25: `Fakturowanie gości`,
  p26: `Warto skorzystać z tych możliwości!`,
  p27: `Przejdź na Premium`,

  p28: `Pozycja`,
  p29: `Opłata dodatkowa`,
  p30: `Status`,
  p31: `Opłacone`,
  p32: `Oczekujące`,
  p33: `Zwrócone`,
  p34: `Zwrot opłaty`,
  p35: `Zwróć`,
  p36: `Czy na pewno zwrócić gościowi tę opłatę?`,
  p37: `Dowód tożsamości`,
  p38: `Paszport`,
  p39:`FILTR`,
  p40:`Check-iny zakończone`,
  p41:`Check-iny w trakcie`,
  p42: `Brak check-inów w trakcie`,
  p43: `Informacje o check-inie`,
  p44: `Powiązane check-iny`,
  p45: `Brak powiązanych check-inów.`,
  p46: `Więcej informacji:`,
  p47: `Data check-inu:`,
  p48: `Data check-outu:`,

  p49:`Gość`,
  p50:`Goście`,


};
